import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { Spinner } from '../Spinner/Spinner';
import { StyledComboboxLoadingState } from './ComboboxLoadingState.styles';

/**
 * @since 8.28.0
 */
export var ComboboxLoadingState = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledComboboxLoadingState, _extends({
    ref: forwardedRef
  }, props), /*#__PURE__*/React.createElement(Spinner, {
    size: "md",
    title: "Loading"
  }));
});
ComboboxLoadingState.displayName = 'ComboboxLoadingState';